/**
 * 热门城市
 */
const HOT_CITY_LIST = [
  // {
  //   name: '全国',
  //   districtName: '全国',
  //   districtID: 'all',
  //   parentDistrictId: 'all',
  // },
  {
    depth: 2,
    districtID: 'XZ1-06',
    districtName: '北京',
    districtAllId: 'XZ1-06',
    districtPreID: '',
    parentDistrictId: 'XZ0-03',
    govLngLat: '116.407170,39.904690',
    simpleName: '北京',
    districtLevel: 'province',
    zoneCode: '',
    districtPathList: [{
      id: 'XZ2-174',
      simpleName: '北京',
      parentId: ''
    }],
  },
  {
    depth: 2,
    districtID: 'XZ1-01',
    districtName: '上海',
    districtAllId: 'XZ1-01',
    districtPreID: '',
    parentDistrictId: 'XZ0-02',
    govLngLat: '121.473700,31.230370',
    simpleName: '上海',
    districtLevel: 'province',
    zoneCode: '',
    districtPathList: [{
      id: 'XZ2-040',
      simpleName: '上海',
      parentId: ''
    }],
  },
  {
    depth: 3,
    districtID: 'XZ2-042',
    simpleName: '广州市',
    districtName: '广东省-广州市',
    districtAllId: 'XZ1-31,XZ2-042',
    districtPreID: 'XZ1-31',
    parentDistrictId: 'XZ1-31',
    govLngLat: '113.264360,23.129080',
    districtLevel: 'city',
    zoneCode: '020',
    districtPathList: [{
      id: 'XZ1-31',
      simpleName: '广东省',
      parentId: ''
    }, {
      id: 'XZ2-042',
      simpleName: '广州市',
      parentId: 'XZ1-31'
    }],
  },
  {
    depth: 3,
    districtID: 'XZ2-229',
    districtName: '广东省-深圳市',
    districtPreID: 'XZ1-31',
    districtAllId: 'XZ1-31,XZ2-229',
    parentDistrictId: 'XZ1-31',
    govLngLat: '114.059560,22.542860',
    simpleName: '深圳市',
    districtLevel: 'city',
    zoneCode: '0755',
    districtPathList: [{
      id: 'XZ1-31',
      simpleName: '广东省',
      parentId: ''
    }, {
      id: 'XZ2-229',
      simpleName: '深圳市',
      parentId: 'XZ1-31'
    }],
  },
  {
    depth: 3,
    districtID: 'XZ2-253',
    districtName: '广东省-东莞市',
    districtPreID: 'XZ1-31',
    parentDistrictId: 'XZ1-31',
    districtAllId: 'XZ1-31,XZ2-253',
    govLngLat: '113.751790,23.020670',
    simpleName: '东莞市',
    districtLevel: 'city',
    zoneCode: '0769',
    districtPathList: [{
      id: 'XZ1-31',
      simpleName: '广东省',
      parentId: ''
    }, {
      id: 'XZ2-253',
      simpleName: '东莞市',
      parentId: 'XZ1-31'
    }],
  },
  {
    depth: 3,
    districtID: 'XZ2-316',
    districtName: '广东省-佛山市',
    districtPreID: 'XZ1-31',
    districtAllId: 'XZ1-31,XZ2-316',
    parentDistrictId: 'XZ1-31',
    govLngLat: '113.121920,23.021850',
    simpleName: '佛山市',
    districtLevel: 'city',
    zoneCode: '0757',
    districtPathList: [{
      id: 'XZ1-31',
      simpleName: '广东省',
      parentId: ''
    }, {
      id: 'XZ2-316',
      simpleName: '佛山市',
      parentId: 'XZ1-31'
    }],
  },
  {
    depth: 3,
    districtID: 'XZ2-311',
    districtName: '广东省-中山市',
    districtPreID: 'XZ1-31',
    districtAllId: 'XZ1-31,XZ2-311',
    parentDistrictId: 'XZ1-31',
    govLngLat: '113.392600,22.515950',
    simpleName: '中山市',
    districtLevel: 'city',
    zoneCode: '0760',
    districtPathList: [{
      id: 'XZ1-31',
      simpleName: '广东省',
      parentId: ''
    }, {
      id: 'XZ2-311',
      simpleName: '中山市',
      parentId: 'XZ1-31'
    }],
  },

]

/**
 * 区域树
 */
const REGION_TREE = {
  districtName: '全国',
  districtID: 'all',
  simpleName: '全国',
  depth: 0,
  depthPath: '0',
  _erpZoom: 0,
  districtLevel: 'china',
  childrenNode: [
    {
      districtName: '华南',
      districtID: 'XZ0-01',
      depth: 1,
      simpleName: '华南',
      depthPath: '0-1',
      childrenNode: [],
      districtLevel: 'area',
      _erpZoom: 0,
      isChecked: false
    },
    {
      districtName: '华东',
      districtID: 'XZ0-02',
      depth: 1,
      simpleName: '华东',
      depthPath: '0-1',
      childrenNode: [],
      districtLevel: 'area',
      _erpZoom: 0,
      isChecked: false
    },
    {
      districtName: '京津冀',
      districtID: 'XZ0-03',
      depth: 1,
      simpleName: '京津冀',
      depthPath: '0-1',
      childrenNode: [],
      districtLevel: 'area',
      _erpZoom: 0,
      isChecked: false
    },
    {
      districtName: '华北',
      districtID: 'XZ0-04',
      depth: 1,
      simpleName: '华北',
      depthPath: '0-1',
      childrenNode: [],
      districtLevel: 'area',
      _erpZoom: 0,
      isChecked: false
    }
  ]
}

const ZOOM_LIST = [
  {
    name: '大区'
  },
  {
    name: '省/直辖市'
  },
  {
    name: '城市'
  },
  {
    name: '区/县'
  },
  {
    name: '镇/街道'
  }
]


export {
  REGION_TREE,
  HOT_CITY_LIST,
  ZOOM_LIST
}



// WEBPACK FOOTER //
// ./src/public/components/kye-area-select/common.js